/** Names of the fixed prize-game colors, each mirrored as `--game-<name>` in src/globals.css and `game-<name>` in Tailwind. */
export type GameColor =
  | "paper"
  | "ink"
  | "ink-light"
  | "ivory"
  | "ivory-deep"
  | "gold-light"
  | "gold"
  | "gold-deep"
  | "stone"
  | "stone-deep"
  | "bulb"
  | "bulb-glow"
  | "foil-light"
  | "foil"
  | "foil-deep"
  | "shade";

/**
 * The prize games' fixed palette (graphite ink, warm ivory, champagne gold, stone, warm bulbs, silver foil). Never
 * rewritten by `applyPalette`: the games sit next to any brand. Source of truth for canvas and SVG gradients.
 */
export const GAME_PALETTE: Readonly<Record<GameColor, string>> = {
  paper: "#FFFFFF",
  ink: "#1F2430",
  "ink-light": "#2A303C",
  ivory: "#F6F1E7",
  "ivory-deep": "#EDE4D3",
  "gold-light": "#F3DC9A",
  gold: "#E9C46A",
  "gold-deep": "#B8893B",
  stone: "#D3CDC2",
  "stone-deep": "#C9C2B6",
  bulb: "#FFFFFF",
  "bulb-glow": "#FFF6D8",
  "foil-light": "#F4F5F7",
  foil: "#C9CDD3",
  "foil-deep": "#A3A9B2",
  shade: "#000000",
};

/** `color` as the space-separated channel triplet its `--game-*` CSS variable holds. */
export function gameChannels(color: GameColor): string {
  const value = parseInt(GAME_PALETTE[color].slice(1), 16);
  return [(value >> 16) & 255, (value >> 8) & 255, value & 255].join(" ");
}

/** `color` from {@link GAME_PALETTE} as comma-separated `rgb()`/`rgba()` at `alpha` (0 to 1); legacy syntax so old WebKit canvases accept it. */
export function gameRgba(color: GameColor, alpha = 1): string {
  const channels = gameChannels(color).split(" ").join(", ");
  return alpha === 1 ? `rgb(${channels})` : `rgba(${channels}, ${alpha})`;
}
